import './SearchSnippet.css';

export interface SearchSnippetProps {
  /** The engine's headline: the matched words wrapped in <mark>. */
  snippet: string;
}

/**
 * Why a story came back.
 *
 * The backend marks the matched words; this splits on those marks and renders
 * the pieces as text and `<mark>` elements. It never sets HTML from the server,
 * because a story's own words are the last place to start trusting markup —
 * the same rule the story body has followed since Phase 12.
 */
export function SearchSnippet({ snippet }: SearchSnippetProps) {
  if (!snippet) return null;

  const pieces = snippet.split(/(<mark>[\s\S]*?<\/mark>)/g).filter(Boolean);

  return (
    <p className="sc-snippet">
      …
      {pieces.map((piece, index) => {
        const matched = piece.startsWith('<mark>');
        const text = matched ? piece.slice(6, -7) : piece;
        return matched ? <mark key={index}>{text}</mark> : <span key={index}>{text}</span>;
      })}
      …
    </p>
  );
}
